import classNames from 'classnames'
import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { IFormPBMManagers } from 'legacy/lut/classes/models/partner360/IFormPBMManagers'
import { ApplyButton } from 'legacy/lut/components/widgets/public/partner360/editors/ApplyButton'
import { DropdownAutocomplete } from 'legacy/lut/components/widgets/public/partner360/editors/DropdownAutocomplete'
import { ValidateInput } from 'legacy/lut/library/validation'
import { useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Item } from 'core-components/library/grid'
import { Controller } from 'core-components/library/validation'
import { ValidationStatus } from 'core-components/library/validation'

import { TranslationKeys } from '../../enums/TranslationKeys'

import { defaultItem, FIELDS_TO_SEARCH_MANAGER } from './configs'
import { getCleanEmail } from './helpers/getCleanEmail'
import { useUserCrud } from './hooks/useUserCrud'

import styles from './CommitmentManagerDialog.module.scss'

interface IManagerDialogProps {
  item?: IFormPBMManagers
  onApply: (item: IFormPBMManagers) => void
  pbmList?: string[]
}

export const ManagerDialog = ({
  item: initialItem = defaultItem,
  onApply,
}: IManagerDialogProps) => {
  const [item, setItem] = useState<IFormPBMManagers>(initialItem)
  const [isChanged, setIsChanged] = useState(false)
  const [validationStatus, setValidationStatus] = useState(ValidationStatus.Invalid)

  const userCrud = useUserCrud()

  const onChange = (newValue: string, fieldName: string) => {
    const cleanValue = getCleanEmail(newValue)

    setItem((prevItem) => ({ ...prevItem, [fieldName]: cleanValue }))

    setIsChanged(true)
  }

  const onChangeEmailItem = async (emailItem: IObjectAny) => {
    if (emailItem && emailItem['Id']) {
      setItem((prevItem) => ({
        ...prevItem,
        ManagerEmail: emailItem['Id'] as string,
        ManagerFirstName: emailItem['FirstName'] as string,
        ManagerLastName: emailItem['LastName'] as string,
      }))
    }

    setIsChanged(true)
  }

  const applyChangesHandler = async () => {
    setIsChanged(false)
    onApply(item)
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Translation text={TranslationKeys.Header} />
      </div>
      <div className={styles.info}>
        <i className={classNames('kbase kbase-info', styles.info__icon)}></i>
        <Translation span text={TranslationKeys.InfoIconContent} />
      </div>
      <Controller
        onValidationStatusChange={({ status }) => {
          status !== 'WIP' && setValidationStatus(status)
        }}
      >
        <Item xs={12}>
          <DropdownAutocomplete
            label={'Email *'}
            fieldsToSearch={FIELDS_TO_SEARCH_MANAGER}
            classes={{
              root: styles.input,
              popPaper: styles.rolePaper,
            }}
            calculateCaption={(item: IObjectAny) =>
              `${item.FirstName} ${item.LastName} <${item.Id}>`
            }
            value={item.ManagerEmail || ''}
            source={userCrud}
            validateName="Id"
            checkFn={ValidationHelper.checkFullEmail}
            onChange={(value: string) => onChange(value, 'ManagerEmail')}
            onItemChange={onChangeEmailItem}
            translation={TranslationKeys.Email}
          />
        </Item>
        <Item xs={12}>
          <ValidateInput
            classes={{
              validatorClasses: {
                root: styles.input,
              },
            }}
            type="text"
            label="First Name *"
            value={item.ManagerFirstName || ''}
            onChange={(value: string) => onChange(value, 'ManagerFirstName')}
            checkFn={(value) => ValidationHelper.checkString(value, 'Please, enter first name')}
            field="ManagerFirstName"
            translation={TranslationKeys.FirstName}
          />
        </Item>
        <Item xs={12}>
          <ValidateInput
            classes={{
              validatorClasses: {
                root: styles.input,
              },
            }}
            type="text"
            label="Last Name *"
            value={item.ManagerLastName || ''}
            onChange={(value: string) => onChange(value, 'ManagerLastName')}
            checkFn={(value) => ValidationHelper.checkString(value, 'Please, enter last name')}
            field="ManagerLastName"
            translation={TranslationKeys.LastName}
          />
        </Item>
      </Controller>
      <div className={styles.buttonLine}>
        <ApplyButton
          className={styles.button}
          disabled={!isChanged || validationStatus !== ValidationStatus.Valid}
          onClick={applyChangesHandler}
        />
      </div>
    </div>
  )
}
